import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { GlobalService } from 'app/global/global.service';

@Pipe({
    name: 'findRecipientRoleById'
})

export class FindRecipientRoleByIdPipe implements PipeTransform {

    constructor(
        private globalService: GlobalService,
        private translocoService: TranslocoService
    ) { }

    transform(roleId: number): string {
        const roles = this.globalService.roles;
        const role = roles.find(r => r.id === roleId);
        return role ? this.translocoService.translate("Tooltip text for assigned role (Template/Document - section) - Assigned to rolename", {rolename: role.role_name}) : '';
    }

}